export default "assets/images/line-9c1e5c22.svg";